<template>
    <div
      class="snack-bar t-rounded t-shadow"
      @mouseenter="stopTimer(),
        prevent_close = true,
        updateSnackbar({ hover: true })
        "
      @mouseleave="updateSnackbar({ hover: false })"
    >
      <div class="snack-bar-activator">
        <slot name="activator"/>
      </div>
      <!-- CONTENT -->
      <div
        class="snack-bar-content"
      >
        <!-- @click="$emit('clickSnackBar')" -->
        <!-- HEADER -->
        <div class="snack-bar-header">
          <slot name="header"/>
        </div>
        <!-- BODY -->
        <div class="snack-bar-body">
          <slot name="body"/>
        </div>
      </div>
      <!-- FOOTER -->
      <slot name="footer"/>
    </div>
</template>

<script>
  // import { mapActions } from 'vuex';
  // import store from '@/store/index'

  export default {
    props: [
      'snackbar'
    ],

    data: () => ({
      prevent_close: false,
      timer: 5,
      interval: ''
    }),

    created() {
      // this.interval = setInterval(this.checkTimer, 1000)
    },

    updated() {
      //reset Timer
      if (!this.snackbar.hover) {
        this.timer = 5;
        if (this.prevent_close) {
          this.prevent_close = false;
          // this.interval = setInterval(this.checkTimer, 1000)
        }
      }
    },

    methods: {
      // ...mapActions('SnackBar', [
      //   'updateSnackbar'
      // ]),

      checkTimer() {
        if (!this.prevent_close && this.timer < 1) {
          this.stopTimer();
          this.updateSnackbar({ show: false });
        } else {
          this.timer--;
        }
      },

      stopTimer() {
        clearInterval(this.interval);
      },

      updateSnackbar(payload){
        this.$emit('updateSnackbar', payload);
      }
    }
  }
</script>

<style>
  .snack-bar {
    position: fixed;
    bottom: 0px;
    left: calc(50%);
    transform: translateX(-50%);
    /* top: calc(100% - 155px); */
    /* left: calc(50% - 150px); */
    /* height: 155px; */
    /* width: 350px; */
    min-width: 360px;
    max-width: min(900px, 100%);
    padding: 4px;
    margin-bottom: 39px; /* must be higher than footer (35px) */
    z-index: 130;
    background-color: var(--v-color-4-base);
    transform-origin: center top;
  }
  .snack-bar:hover{
    background-color: var(--v-color-3-base) !important;
  }
  .snack-bar-content {
    padding: 4px;
  }
  .snack-bar-header {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .snack-bar-body {
    display: flex;
    border-top: 1px solid var(--v-primary-base);
    border-bottom: 1px solid var(--v-primary-base);
    justify-content: center;
    align-items: center;
  }
  .snack-bar-activator {
    position: absolute;
    left: 50%;
    top: 0px;
  }
</style>
